import { Controller } from "@hotwired/stimulus"

// Index des plans d'action : gère l'état d'URL (view_type / sort / recherche /
// filtre statut). Navigation pleine page pour re-rendre la vue serveur.
export default class extends Controller {
  static targets = ["searchInput"]
  static values  = { baseUrl: String, currentView: String }

  connect() {
    window.__planIndex = this
  }

  switchViewType(event) {
    const t = event.currentTarget.dataset.viewType
    if (!t) return
    this.navigateWith({ view_type: t })
  }

  changeSort(event) {
    const [field, direction] = event.currentTarget.value.split(":")
    this.navigateWith({ sort_field: field, sort_direction: direction })
  }

  changeGroupBy(event) {
    this.navigateWith({ group_by: event.currentTarget.value })
  }

  submitSearch(event) {
    event?.preventDefault?.()
    const value  = this.hasSearchInputTarget ? this.searchInputTarget.value.trim() : ""
    const params = this._currentParams()
    Object.keys(params).forEach(p => { if (p.startsWith("filters[search]")) delete params[p] })
    if (value) {
      params["filters[search][op]"]    = "contains"
      params["filters[search][value]"] = value
    }
    delete params["page"]
    this._navigate(params)
  }

  clearSearch() {
    if (this.hasSearchInputTarget) this.searchInputTarget.value = ""
    this.submitSearch()
  }

  toggleStatut(event) {
    const statut = event.currentTarget.dataset.statut
    const params = this._currentParams()
    Object.keys(params).forEach(p => { if (p.startsWith("filters[statut]")) delete params[p] })
    if (statut) {
      params["filters[statut][op]"]       = "in"
      params["filters[statut][value][]"]  = statut
    }
    delete params["page"]
    this._navigate(params)
  }

  navigateWith(extra) {
    const params = this._currentParams()
    Object.entries(extra || {}).forEach(([k, v]) => {
      if (v === null || v === undefined || v === "") delete params[k]
      else params[k] = v
    })
    this._navigate(params)
  }

  _currentParams() {
    const url = new URL(window.location.href)
    const out = {}
    url.searchParams.forEach((value, key) => {
      if (key.endsWith("[]")) { (out[key] = out[key] || []).push(value) }
      else out[key] = value
    })
    return out
  }

  _navigate(params) {
    const url = new URL(window.location.href)
    url.search = ""
    Object.entries(params).forEach(([key, val]) => {
      if (val === null || val === undefined) return
      if (Array.isArray(val)) val.forEach(v => url.searchParams.append(key, v))
      else url.searchParams.set(key, val)
    })
    window.location.href = url.toString()
  }
}
